import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const CardWrapper = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  left: 0;
  z-index: 100;
  padding: 24px 18px;
  background: ${COLOR.WHITE_1};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.45);
  border-radius: 6px;
  margin: 10px 18px;
  h3 {
    margin-bottom: 16px;
  }
  a {
    text-decoration: underline;
    font-weight: 500;
    color: ${COLOR.GREEN_2};
  }
  p {
    margin: 1rem 0;
  }
  .MuiIconButton-root {
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const BoxButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 100%;
    margin: 32px auto 0 auto;
    max-width: 288px;
  }

  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    button {
      margin: 32px auto 0 auto;
      max-width: 320px;
    }
  }
`;
